export enum RULE_MESSAGE_TYPE {
	Info = 'Info',
	Warning = 'Warning',
	Error = 'Error'
}

export enum RULE_SEVERITY {
	UNKNOWN = 'Unknown',
	LOW = 'Low',
	MODERATE = 'Moderate',
	HIGHT = 'High'
}

export enum RULE_STATUS {
	NOT_REVIEWED = 'NotReviewed', // 0
	FLAG = 'Flag', // 1
	PASSED = 'Passed', // 2
	FAILED = 'Failed'
}

export enum RULE_TYPE {
	PROPERTY_RISK = 'PropertyRisk',
	COMPILANCE = 'Compliance',
	COMPLETENESS = 'Completeness',
	REASONABILITY = 'Reasonability',
	CONSISTENCY = 'Consistency',
	REPORT_RISK = 'ReportRisk',
	COMPLEXITY = 'Complexity',
	CEHCKLIST = 'Checklist',
}

export enum RULES_INDICATOR {
	COMPLETE = 'Completed',
	NODEFFERED = 'NoDeffered',
	INPROCESS = 'Inprocess'
}

export enum RULES_STATUS_INDICATOR {
	UNKNOWN = 'UNKNOWN',
	IDLE = 'IDLE',
	INPROCESS = 'INPROCESS',
	COMPLETE = 'COMPLETE',
	FAILED = 'FAILED'
}

export enum TRANSITION_STATE {
	IS_OPEN = 'isOpen',
	IS_CLOSE = 'isClose'
}

export enum SUB_PANEL_TYPE {
	CREATE_RULE = 'create_rule',
	ADD_COMMENT = 'add_comment',
	ADD_STIP = 'add_stip',
	VIEW_COMMENTS_AND_STIPS = 'view_comments_and_stips',
	VIEW_RULE_NOTIFICATIONS = 'view_rule_notifications'
}

export enum VIEW_COMMENTS_MODE {
	COMMENTS = 'comment',
	STIPS = 'stips'
}

export enum ORDER_STATE {
	ACTIVE = 'Active',
	APPROVE = 'Approve',
	REJECT = 'Reject',
	APPROVED = 'Approved',
	REJECTED = 'Rejected',
	RECALLED = 'Recalling',
	INQUALITY = 'UnderReview',
	QUEUED = 'Queued',
	REVISION_RECEIVED = 'RevisionReceived',
	CANCELLED = 'Cancelled'
}

export const RULES_RUNNING_EVENT = 'RULES_RUNNING_EVENT';
